// src/components/auth/TermsAndPrivacyPage.jsx
// ==============================================
// A standalone page to display the Terms of Service and Privacy Policy.
// This component provides a stable, non-modal view accessible via direct URL.
// ==============================================

import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TermsAndPrivacy } from './TermsAndPrivacy';
import { ArrowLeft } from 'lucide-react';
import { CatLogo } from '@/components/CatLogo';

const TermsAndPrivacyPage = () => {
  const navigate = useNavigate();
  const location = window.location.pathname;
  
  // Determine the initial tab based on the URL
  const initialTab = location.includes('/privacy') ? 'privacy' : 'terms';

  const handleClose = () => {
    // If there's a history, go back. Otherwise, go to the homepage.
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="fixed inset-0 bg-background text-on-surface z-[2000] flex flex-col items-center justify-center p-4">
       <div className="absolute top-6 left-6 z-50">
          <button
            onClick={handleClose}
            className="flex items-center space-x-2 
                     text-on-surface-dim hover:text-on-surface transition-colors duration-200
                     bg-surface/80 hover:bg-surface rounded-md px-3 py-1.5"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Back</span>
          </button>
      </div>

      <div className="w-full max-w-4xl">
         <TermsAndPrivacy 
            onClose={handleClose}
            initialTab={initialTab}
          />
      </div>
    </div>
  );
};

export default TermsAndPrivacyPage;